import styled from "styled-components";
import {
  carouselHeaderFontStyleFix,
  carouselHeaderMarginFix,
} from "src/website-apps/shared/components/tm-home-fix-header-sizing/util";

export const StyledTitle = styled.p`
  color: ${(props) => props.theme.colors.backgroundDark};
  ${({
    theme: {
      typography: { getStyles, variant, fontWeight },
    },
  }) => getStyles(variant.title5, fontWeight.bold)};
  padding-bottom: ${(props) => props.theme.spacing(4)};
  @media ${({ theme: { media } }) => media.phone} {
    padding-bottom: 0;
  }
  ${carouselHeaderFontStyleFix};
  ${carouselHeaderMarginFix};
`;
